import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { t } from '../../../services/i18nService';
import styles from './annotationItem.scss';
import annotationService from '../../../services/AnnotationService';
import questionUtils from '../../../qti/utils/questionUtils';
import objectTypes from '../../../constants/ObjectTypes';

const DeleteButtons = ({ id, questionNumber, questionId, selector, type }) => {
    const [confirmMode, setConfirmMode] = useState(false);

    const setDefaulMode = (event) => {
        event.stopPropagation();
        setConfirmMode(false);
    };

    const setDeletingMode = (event) => {
        event.stopPropagation();
        setConfirmMode(true);
    };

    const removeAnnotation = (event) => {
        event.stopPropagation();
        annotationService.removeAnnotation(questionId, selector, id);
    };

    const getDeleteMessage = () => {
        if (type === objectTypes.CATEGORY.STIMULUS) {
            return t('annotationItem.deleteAlert.stimulusNote', { questionNumber });
        }
        if (questionUtils.isQuestionRange(questionNumber)) {
            return t('annotationItem.deleteAlert.multipleQuestions', { questionNumber });
        }
        return t('annotationItem.deleteAlert.ariaLabelText', { questionNumber });
    };

    return (
        <>{confirmMode ?
            <div className={styles.confirmDeleteGroup}>
                <p
                    className={styles.confirmDeleteAnnotationItemAlert}
                    role="alert"
                >
                    {getDeleteMessage()}
                </p>
                <button
                    aria-label={t('annotationItem.cancelButton.ariaLabelText', { questionNumber })}
                    className={`${styles.linkTypeButton} ${styles.cancelButton}`}
                    onClick={setDefaulMode}
                >
                    {t('general.cancel')}
                </button>

                <button
                    className={`${styles.linkTypeButton} ${styles.confirmButton}`}
                    onClick={removeAnnotation}
                    aria-label={t('annotationItem.confirmButton.ariaLabelText', { questionNumber })}
                >
                    {t('button.confirmDeleting')}
                </button>
            </div> :

            <button
                className={`${styles.linkTypeButton} ${styles.deleteButton}`}
                onClick={setDeletingMode}
                aria-label={t('annotationItem.deleteButton.ariaLabelText', { questionNumber })}
            >
                {t('button.delete')}
            </button>
        }</>
    );
};

DeleteButtons.propTypes = {
    id: PropTypes.string.isRequired,
    questionNumber: PropTypes.string,
    questionId: PropTypes.number.isRequired,
    selector: PropTypes.array.isRequired,
    type: PropTypes.string,
};

export default DeleteButtons;
